import { Input, Button, Space, Tag } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import _ from 'lodash';

export const ClientTableConfig = (
  handleSearch,
  handleReset,
  onDelete,
  editProductCategory,
  responsibilities,
) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'ID',
      dataIndex: 'client_id',
      key: 'client_id',
      width: '2%',
    },
    {
      title: 'Name',
      dataIndex: 'client_name',
      key: 'client_name',
      width: '5%',
      ...getColumnSearchProps('client_name'),
    },
    {
      title: 'Sur Name',
      dataIndex: 'last_name',
      key: 'last_name',
      width: '5%',
      ...getColumnSearchProps('last_name'),
    },
    // {
    //   title: 'Email Verified',
    //   dataIndex: 'email_verified',
    //   key: 'email_verified',
    //   width: '10%',
    //   render: (status) => {
    //     return <Tag color={status ? 'green' : 'red'}>{status ? 'Yes' : 'No'}</Tag>;
    //   },
    // },
    // {
    //   title: 'Reserved Amount',
    //   dataIndex: 'reserved_amount',
    //   key: 'reserved_amount',
    //   width: '10%',
    // },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '10%',
      render: (status) => {
        return (
          <Tag color={_.isEqual(status, 1) ? 'green' : 'red'}>
            {_.isEqual(status, 1) ? 'Active' : 'In Active'}
          </Tag>
        );
      },
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: '2%',
      render: (item) => {
        return (
          <div>
            <Space size="middle">
              <EyeOutlined style={{ color: '#0D8616', cursor: 'pointer', fontSize: '20px' }} />
              {_.includes(responsibilities, 'PRODUCT_CATEGORY_EDIT_BUTTON') ? (
                <EditOutlined
                  style={{ color: '#0D4B86', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => editProductCategory(item)}
                />
              ) : (
                ''
              )}
              {_.includes(responsibilities, 'PRODUCT_CATEGORY_DELETE_BUTTON') ? (
                <DeleteOutlined
                  style={{ color: '#F52A0E', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => onDelete(item)}
                />
              ) : (
                ''
              )}
            </Space>
          </div>
        );
      },
    },
  ];
};
